module.exports = __webpack_public_path__ + "static/media/handschuhe_richtig_active_arbeitsmittel_true.669e9388.jpg";